module.exports = __webpack_public_path__ + "img/social-rewards.829e9200.png";